import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export const Home: React.FC = () => {
  return (
    <div className="home-page">
      <Header />
      <main className="main-content">
        <section className="hero">
          <div className="hero-content">
            <img
              src="/app-logo.png"
              alt=""
              width={120}
              height={120}
              className="hero-logo"
            />
            <h1 className="hero-title">Good Old Maps</h1>
            <p className="hero-subtitle">
              Explore nearby maps. Upload yours. Track your location.
            </p>
            <div className="download-links">
              <a
                href="https://apps.apple.com/us/app/good-old-maps/id6759081900"
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn ios"
              >
                <span className="ios-download-icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={22} height={22} fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                </span>
                Download for iOS
              </a>
              <span className="download-btn android coming-soon" role="status">
                🤖 Android (coming soon)
              </span>
            </div>
          </div>
        </section>

        <section className="features">
          <div className="container">
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">📍</div>
                <h3>GPS on any map image</h3>
                <p>Use any map image on your phone or from a URL and see your live location on it</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🧭</div>
                <h3>Calibrate in minutes</h3>
                <p>
                  Tap points on the map and mark where you are standing. Two reference pairs unlock positioning; add more
                  to tighten accuracy across the whole image.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🌐</div>
                <h3>Browse &amp; upload</h3>
                <p>
                  Explore maps other people have shared, or bring your own from the camera or a URL. Keep maps on your
                  device or sync them when you are online.
                </p>
              </div>
            </div>
            <img
              src="/images/good_old_maps_comic.png"
              alt="Good Old Maps comic illustration"
              className="feature-comic"
              loading="lazy"
            />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

























